import { Button, Col, Input, Row, Text } from 'components';
import { Api } from 'lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const ChangePassword = () => {
  const { isMobile, language } = useSelector((state) => state.appState),
    [oldPassword, setOldPassword] = useState(''),
    [newPassword1, setNewPasword1] = useState(''),
    [newPassword2, setNewPasword2] = useState(''),
    [errs, setErrs] = useState([]),
    { t } = useTranslation(),
    navigate = useNavigate(),
    dispatch = useDispatch(),
    isDisabled = oldPassword.length < 8 || newPassword1.length < 8 || newPassword2.length < 8;

  async function changePassword() {
    if (newPassword1 !== newPassword2) {
      setErrs([
        { input: 'newPassword1', err: t('forgotPassword.doesntMatch') },
        { input: 'newPassword2', err: t('forgotPassword.doesntMatch') }
      ]);

      return;
    }

    const res = await Api.post(
      '/users/changePassword',
      { oldPassword, newPassword: newPassword1 },
      'changePassword'
    );
    if (!res) return;
    if (res.err) return setErrs([res]);

    setOldPassword('');
    setNewPasword1('');
    setNewPasword2('');
    setErrs([]);

    dispatch({
      type: 'HANDLE_RES',
      payload: { res: t('settings.passwordChangeSuccessful') }
    });
  }

  return (
    <Col wid="100%">
      <Row between center marg="24px 0 0">
        <Text b1 bold>
          {t('settings.oldPassword')}
        </Text>

        <Input
          wid={isMobile ? '230px' : '334px'}
          marg="0 2px 0 0"
          password
          value={oldPassword}
          onChange={({ target }) => setOldPassword(target.value)}
          error={errs.find((x) => x.input === 'oldPassword')?.err}
        />
      </Row>

      <Row between center marg="24px 0 0">
        <Text b1 bold>
          {t('settings.newPassword')}
        </Text>

        <Input
          wid={isMobile ? '230px' : '334px'}
          marg="0 2px 0 0"
          password
          value={newPassword1}
          onChange={({ target }) => {
            setNewPasword1(target.value);

            setErrs(errs.filter((x) => x.input !== 'newPassword1'));
          }}
          error={errs.find((x) => x.input === 'newPassword1')?.err}
        />
      </Row>

      <Row between center marg="24px 0 0">
        <Row wid={isMobile ? '112px' : 'unset'} maxWid="252px">
          <Text b1 bold>
            {t('settings.confirmNewPassword')}
          </Text>
        </Row>

        <Input
          wid={isMobile ? '230px' : '334px'}
          marg="0 2px 0 0"
          password
          value={newPassword2}
          onChange={({ target }) => {
            setNewPasword2(target.value);

            setErrs(errs.filter((x) => x.input !== 'newPassword2'));
          }}
          error={errs.find((x) => x.input === 'newPassword2')?.err}
        />
      </Row>

      <Row between wid="100%" marg="24px 0 0">
        {!isMobile && <Row />}

        <Row wid={isMobile ? '100%' : '336px'} gap="12px">
          <Button
            text={t('settings.changePassword')}
            onClick={changePassword}
            disabled={isDisabled}
            action="changePassword"
          />

          <Button
            text={t('settings.forgotPassword')}
            bordered
            onClick={() => navigate('/forgot-password')}
          />
        </Row>
      </Row>
    </Col>
  );
};

export default ChangePassword;
